import { CalendarSlotCell } from "./CalendarSlotCell";


export class CalendarWeekDay {
  dayOfWeek: string; 
  date: string;     
  slots: CalendarSlotCell[];

  constructor() {
    this.dayOfWeek = '';
    this.date = '';
    this.slots = [];
  }
}
